import { render } from "./Multicast.vue?vue&type=template&id=b031f21c&scoped=true"
import script from "./Multicast.vue?vue&type=script&lang=js"
export * from "./Multicast.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b031f21c"

export default script